@if (asset?.baseInfoLink) {
  <ng-container *ngTemplateOutlet="link; context: { href: asset.baseInfoLink, label: 'baseInfoLink' }" />
}
@if (asset?.salesbrochure) {
  <ng-container *ngTemplateOutlet="link; context: { href: asset.salesbrochure, label: 'salesbrochure' }" />
}
@if (asset?.semiAnnualReport) {
  <ng-container *ngTemplateOutlet="link; context: { href: asset.semiAnnualReport, label: 'semiAnnualReport' }" />
}
@if (asset?.annualReport) {
  <ng-container *ngTemplateOutlet="link; context: { href: asset.annualReport, label: 'annualReport' }" />
}

<ng-template #link let-href="href" let-label="label">
  <div class="font-size-smaller2">
    <a class="link link-secondary" [href]="href" target="_blank" rel="noopener noreferrer" [attr.data-zid]="label">
      {{ 'trade.confirm.links.' + label | transloco }}
    </a>
  </div>
</ng-template>
